import { motion, useInView } from "framer-motion";
import { useEffect } from "react";
import { useRef } from "react";

import { images } from "../../constants";
import { MainPageWrap } from "../../wrapper";

import "./Hero.scss";
import { WavingHand } from "./WavingHand";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Hero = ({ handleActiveIndex }) => {
  const heroRef = useRef();
  const isInView = useInView(heroRef, { margin: "-10px 0px 0px 0px" });

  useEffect(() => {
    if (isInView) {
      handleActiveIndex(0);
    }
  }, [isInView]);

  return (
    <div className="hero" ref={heroRef}>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="hero__info"
      >
        <div className="hero__badge">
          <WavingHand />
          <div className="hero__header">
            <p className="p-text">Hello, I am</p>
            <h1 className="hero__title">Arthur</h1>
          </div>
        </div>
        <div className="hero__speciality">
          <p className="p-text">frontend developer</p>
        </div>
      </motion.div>
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="hero__image-section"
      >
        <img src={images.profile} alt="Artur" />
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          src={images.circle}
          className="overlay-circle"
          alt="Circle"
        />
      </motion.div>
      <motion.div
        className="hero__stack"
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
      >
        <div className="header__circle">
          <img src={images.redux} alt="Redux" />
        </div>
        <div className="header__circle">
          <img src={images.react} alt="React" />
        </div>
        <div className="header__circle">
          <img src={images.javascript} alt="JavaScript" />
        </div>
      </motion.div>
    </div>
  );
};

export default MainPageWrap(Hero, "home");
